import TabsContainer from './TabsContainer'
import TabsButton from './TabsButton'
import TabsContent from './TabsContent'

export default {
  TabsContainer,
  TabsContent,
  TabsButton
}
